import React from 'react';
import Seo from '../../components/Seo';
import PolicyHero from '../../components/PolicyHero';
import NewFooter from '../../components/NewFooter';
import InfoCards from '../../components/HomePage/InfoCards';
import ContactForm, { CONTACT_FORM_CLASSES } from '../../components/ContactForm/ContactForm';
import './contact.css';

const HERO_IMAGE = '/assets/new_assets/contact-banner.png';
const MAP_SRC =
  'https://maps.google.com/maps?q=My%20Private%20Chemist%2C%20Longcroft%20House%2C%20The%20small%20road%20between%20the%20Police%20Station%20and%20Five%20Guys%2C%202-8%20Victoria%20Ave%2C%20London%20EC2M%204NS%2C%20United%20Kingdom&t=m&z=17&output=embed&iwloc=near';

/* ── Contact Page ────────────────────────────────────────────── */

function ContactPage() {
  return (
    <div className="cn-page">
      <Seo
        title="My Private Chemist | Contact"
        description="Get in touch with My Private Chemist in Victoria, London. Call, email or send us a message — our team is ready to help with your health questions."
        canonical={`${process.env.REACT_APP_BASE_URL}/contact`}
        url={`${process.env.REACT_APP_BASE_URL}/contact`}
        image={`${process.env.REACT_APP_BASE_URL}${HERO_IMAGE}`}
      />
      <PolicyHero
        title="Contact"
        pageName="Contact"
        heroImage={HERO_IMAGE}
      />

      {/* Info cards */}
      <InfoCards />

      {/* Contact form */}
      <section className="cn-form-section" aria-label="Contact form">
        <div className="cn-form-inner">

          <div className="cn-form-col cn-form-col--heading">
            <h4 className="cn-form-heading">
              Have a question?<br />
              Drop us a line!
            </h4>
          </div>

          <div className="cn-form-col cn-form-col--fields">
            <ContactForm
              idPrefix="cn"
              classNames={CONTACT_FORM_CLASSES.contactPage}
              submitLabel="Send Message"
              sendingLabel="Sending…"
              textareaRows={4}
            />
          </div>

        </div>
      </section>

      {/* Map */}
      <section className="cn-map-section" aria-label="Our location on map">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <iframe
                src={MAP_SRC}
                className="cn-map"
                title="My Private Chemist location"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>

      <NewFooter />
    </div>
  );
}

export default ContactPage;
